

const autoGiftPropName = '_auto_gift'
const promoIdPropName = '_promo_id'
const discountProductCollectionHandlePropName = '_discount_product_collection_handle'

const BUY_X_GET_Y_FOR_Z = []
const MOTIVATOR = [
  // #  Buy any items above $1000, free GWP 
  {
    promo_id: '買滿$1000送贈品',
    promo_type: 'motivator',
    minimum_purchase: 1000,

    trigger_product_selector_match_type: ':all',
    trigger_product_selector_type: ':variant_id',
    trigger_product_selectors: [],

    discount_product_list: [
      {
        product_selector_match_type: ':include',
        product_selector_type: ':variant_id',

        product_selectors: [42581807333565],
        product_collection_handle: 'all-products',
        quantity_to_discount: 1,

        can_manual_select: 0,

        discount_type: ':percent',
        discount_amount: 100,
        discount_message: '買滿$1000送贈品',
      },
    ]
  }
]

const BUNDLE_DISCOUNTS = []
  
const getPromoList = () => {
  //  warning: since in here, don't know why cannot access shop.metafields, so hardcode here
  const promoList = [
    ...BUY_X_GET_Y_FOR_Z.map(x => { return { promoType: 'buyXGiveY', promoConfig: { ...x } } }),
    ...MOTIVATOR.map(x => { return { promoType: 'motivator', promoConfig: { ...x } } }),
  ]
  return promoList
}

class ProductSelector {
  constructor(match_type, selector_type, selectors) {
    this.match_type = match_type;
    this.selector_type = selector_type;
    this.selectors = selectors;
  }

  match(line_item) {
    const functionName = this.selector_type.replace(':', '')
    return this[functionName](line_item)
  }

  tag(line_item) {
    const tags = (line_item.tags || []).map(x => x.toLowerCase())
    if ((this.match_type === ':include')) {
      return tags.some(tag => this.selectors.includes(tag))
    }
    return tags.some(tag => !this.selectors.includes(tag))
  }

  type(line_item) {
    this.selectors = this.selectors.map(x => x.toLowerCase())
    return (this.match_type === ':include') === this.selectors.includes(line_item.product_type)
  }

  vendor(line_item) {
    this.selectors = this.selectors.map(x => x.toLowerCase())
    return (this.match_type === ':include') === this.selectors.includes(line_item.vendor)
  }

  variant_id(line_item) {
    return (this.match_type === ':include') === this.selectors.includes(line_item.variant_id)
  }

  product_id(line_item) {
    return (this.match_type === ':include') === this.selectors.includes(line_item.product_id)
  }

  all(line_item) {
    return true
  }
}



/* 
Examples of call:
Shopify.formatMoney(600000, '&euro; EUR')
Shopify.formatMoney(600000, '&euro; EUR')
Shopify.formatMoney(600000, '$')
Shopify.formatMoney(600000, '') in a Liquid template!

In a Liquid template, you have access to a shop money formats with:



All these formats are editable on the Preferences page in your admin.
*/
const formatMoney = (cents, format) => {
  if (typeof cents == 'string') cents = cents.replace('.','');
  var value = '';
  var patt = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function addCommas(moneyString) {
    return moneyString.replace(/(\d+)(\d{3}[\.,]?)/,'$1,$2');
  }

  const floatToString = (numeric, decimals) => {
    var amount = numeric.toFixed(decimals).toString();
    if(amount.match(/^\.\d+/)) {return "0"+amount; }
    else { return amount; }
  }

  switch(formatString.match(patt)[1]) {
  case 'amount':
    value = addCommas(floatToString(cents/100.0, 2));
    break;
  case 'amount_no_decimals':
    value = addCommas(floatToString(cents/100.0, 0));
    break;
  case 'amount_with_comma_separator':
    value = floatToString(cents/100.0, 2).replace(/\./, ',');
    break;
  case 'amount_no_decimals_with_comma_separator':
    value = addCommas(floatToString(cents/100.0, 0)).replace(/\./, ',');
    break;
  }
  return formatString.replace(patt, value);
};

const isPromo = (item, promo_id) => {
  return item.properties && item.properties[promoIdPropName] && item.properties[promoIdPropName] === promo_id
}

const isGiftLineItem = (item) => {
  return item.properties && item.properties[autoGiftPropName]
}

const isUnfulfilledGiftLineItem = (item) => {
  return isGiftLineItem(item) && !item.properties[discountProductCollectionHandlePropName]
}

const getGiftLineItemList = (cart) => {
  return cart.items.filter(item => isGiftLineItem(item))
}

const getNonGiftLineItemList = (cart) => {
  return cart.items.filter(item => !isGiftLineItem(item))
}

const getSumQuantity = (itemList) => {
  return itemList.reduce((sum, current, index) => sum + current.quantity, 0)
}

const getSumFinalPrice = (itemList) => {
  return itemList.reduce((sum, current, index) => sum + current.final_line_price, 0)
}

const getLatestCartNonGiftSubtotal = (cart, productSelector) => {
  let itemList = getNonGiftLineItemList(cart).filter(item => productSelector.match(item))
  return getSumFinalPrice(itemList)
}

const getLatestCartSubtotal = (cart, productSelector) => {
  let itemList = cart.items.filter(item => productSelector.match(item))
  return getSumFinalPrice(itemList)
}

class PromotionHandler {
  constructor(cart) {
    this.promoList = getPromoList()
    this.cart = cart
  }

  checkBuyXGiveY(promo) {

    const {
      promo_id,
      trigger_product_selector_match_type,
      trigger_product_selector_type,
      trigger_product_selectors,
      discount_product_list,
      quantity_to_trigger,
      max_trigger

    } = promo.promoConfig


    console.log(`promoConfig`, promo.promoConfig)


    let missingVariantList = []

    const triggerProductSelector = new ProductSelector(
      trigger_product_selector_match_type,
      trigger_product_selector_type,
      trigger_product_selectors
    )

    const nonGiftLineItemList = getNonGiftLineItemList(this.cart)
    const trigger_items = nonGiftLineItemList.filter(item => triggerProductSelector.match(item))
    const trigger_items_qty = getSumQuantity(trigger_items)

    const possible_trigger_bundle = Math.floor(trigger_items_qty / quantity_to_trigger)

    discount_product_list.forEach(discount_product => {

      const {
        product_selector_match_type: discount_product_selector_match_type,
        product_selector_type: discount_product_selector_type,
        product_selectors: discount_product_selectors,
        quantity_to_discount,
      } = discount_product

      const discountProductSelector = new ProductSelector(
        discount_product_selector_match_type,
        discount_product_selector_type,
        discount_product_selectors
      )

      const giftLineItemList = getGiftLineItemList(this.cart)
      const discount_items = giftLineItemList
        .filter(item => discountProductSelector.match(item))
        .filter(x => isPromo(x, promo_id))

      const discount_items_qty = getSumQuantity(discount_items)
      console.log(`discount_items_qty`, discount_items_qty)

      const expected_discount_items_qty = Math.min(possible_trigger_bundle, max_trigger) * quantity_to_discount
      console.log(`expected_discount_items_qty`, expected_discount_items_qty)
      const missingQty = Math.max(expected_discount_items_qty - discount_items_qty, 0)
      console.log(`missingQty`, missingQty)

      const alternativeVariantIdList = discount_product_selectors

      if (missingQty) {
        missingVariantList.push({ alternativeVariantIdList, missingQty })
      }
    });

    return {
      missingVariantList,
      ...promo
    }

  }

  checkMotivator(promo) {

    const {
      promo_id,
      minimum_purchase,
      discount_product_list,
      trigger_product_selector_match_type,
      trigger_product_selector_type,
      trigger_product_selectors
    } = promo.promoConfig

    const triggerProductSelector = new ProductSelector(
      trigger_product_selector_match_type,
      trigger_product_selector_type,
      trigger_product_selectors
    )

    const sum = getLatestCartSubtotal(this.cart, triggerProductSelector)

    console.log(`sum`, sum)

    let missingVariantList = []

    if (sum >= minimum_purchase * 100) {
      discount_product_list.map(discount_product => {

        const { quantity_to_discount, product_selector_match_type, product_selector_type, product_selectors } = discount_product

        const productSelector = new ProductSelector(product_selector_match_type, product_selector_type, product_selectors)

        const giftItemList = getGiftLineItemList(this.cart)

        console.log(`this.cart`, this.cart)
        console.log(`giftItemList`, giftItemList)
        const foundGiftItemList = giftItemList
          .filter(item => productSelector.match(item))
          .filter(x => isPromo(x, promo_id))

        console.log(`foundGiftItemList`, foundGiftItemList)

        const alternativeVariantIdList = product_selectors

        const foundGiftItemQty = foundGiftItemList.reduce((sum, current, index) => sum + current.quantity, 0)
        const missingQty = Math.max(quantity_to_discount - foundGiftItemQty, 0)

        console.log('motivator missingQty', missingQty)

        if (missingQty) {
          missingVariantList.push({ alternativeVariantIdList, missingQty })
        }
      })
    }

    const result = {
      missingVariantList,
      ...promo
    }
    return result

  }

  async calculateAndAddMissing() {

    const tryAddVariant = async (promoConfig, alternativeVariantIdList, quantity) => {

      const { promo_id, promo_name, promo_type } = promoConfig

      console.log(`promo_id: ${promo_id} need to add variant ${alternativeVariantIdList} x ${quantity} times`)
      let addedVariantId = '';

      const properties = {
        [promoIdPropName]: promo_id,
        [autoGiftPropName]: "1" // warning, this value is text 
      }

      for (let index = 0; index < alternativeVariantIdList.length; index++) {
        const variantId = alternativeVariantIdList[index];

        try {
          // add the 
          await Shopify.addItemWithPropertiesHandleErrorPromise(variantId, quantity, properties)
          addedVariantId = variantId;
          break

        } catch (error) {
          console.log(error)
          console.log(`failed to add variantId: ${variantId}`)
        }

      }
      console.log(`addedVariantId`, addedVariantId)

      if (!addedVariantId) {
        if (promo_type === 'motivator') {
          Shopify.showError(`由於庫存不足，此贈品優惠現不適用。`)
        }
        else if (promo_type === 'buyXGiveY') {
          Shopify.showError(`由於庫存不足，此折扣優惠現不適用。`)
        }
        else {
          Shopify.showError(`由於庫存不足，此<b>${promo_id}</b>現不適用。`)
        }
      }

    }

    const calculatePromo = (promo) => {
      let result = {
        missingVariantList: [],
        ...promo
      }

      if (promo.promoType === 'buyXGiveY') {
        console.log(`promo`, promo)
        return this.checkBuyXGiveY(promo)
      }

      if (promo.promoType === 'motivator') {
        return this.checkMotivator(promo)
      }

      return result
    }

    console.log(`this.promoList`, this.promoList)

    for (let x = 0; x < this.promoList.length; x++) {

      const promo = this.promoList[x]

      const { missingVariantList, promoConfig } = calculatePromo(promo)

      console.log(`missingVariantList`, missingVariantList)
      const promo_id = promoConfig.promo_id
      console.log(`promo_id`, promo_id)

      for (let index = 0; index < missingVariantList.length; index++) {
        const missingVariant = missingVariantList[index];

        const { alternativeVariantIdList, missingQty } = missingVariant

        await tryAddVariant(promoConfig, alternativeVariantIdList, missingQty)
        this.cart = await Shopify.getCartPromise()
      }
    }

    console.log(`calculate Complete`)
  }

  async cleanOutOfStock() {
    // get distinct variantId List
    const distinctProductHandleList = [...new Set(this.cart.items.map(item => item.handle))]

    const promiseList = distinctProductHandleList.map(handle => Shopify.getProductPromise(handle))
    const productJsonList = await Promise.all(promiseList)

    console.log(`productJsonList`, productJsonList)
  
    // call api to check variantId stock

    const outOfStockItemList = this.cart.items.reduce(((resultList, item) => {

      const { handle, variant_id } = item

      const foundProductJson = productJsonList.find(productJson => productJson.handle === handle)
      const foundVariant = foundProductJson.variants.find(variant => variant.id === variant_id)

      if (!foundVariant.available) {
        resultList.push(item)
      }
      return resultList
    }), [])

    console.log(`outOfStockItemList`, outOfStockItemList)

    for (let index = 0; index < outOfStockItemList.length; index++) {
      const outOfStockItem = outOfStockItemList[index];
      const { key } = outOfStockItem
      const latestCart = await Shopify.changeItemWithLineItemKeyPromise(key, 0)
      this.cart = latestCart
    }

    console.log(`final cart`, this.cart)

  }
  
}

async function checkForCanRedeemPromoList(cart) {

  const promotionHandler = new PromotionHandler(cart)

  await promotionHandler.cleanOutOfStock()
  await promotionHandler.calculateAndAddMissing()
  // await promotionHandler.cleanGift()
}

const PROPERTY_NAME_PROMO = "__promo"
const PROPERTY_NAME_GIFT = "__gift"
const TAG_PREFIX_RULE = "rule"

// just used to check if waveCartUtils can be successfully called
function healthCheck() {
  console.log(`waveCartUtils OK!`)
  console.log(`waveLiquidRoutes`, waveLiquidRoutes)
}

function Mutex() {
  let current = Promise.resolve();
  this.lock = () => {
    let _resolve;
    const p = new Promise(resolve => {
      _resolve = () => resolve();
    });
    // Caller gets a promise that resolves when the current outstanding
    // lock resolves
    const rv = current.then(() => _resolve);
    // Don't allow the next request until the new promise is done
    current = p;
    // Return the new promise
    return rv;
  };
};

function isDummy(item) {
  return item.product.tags.some((tag) => tag.includes("rule:bundle"));
}

function promoProp(item) {
  const props = item.properties.find((props) => props[0] == PROPERTY_NAME_PROMO);
  if (props) {
    return props[1];
  }
}

function bundleSet(item) {
  return isDummy(item) ? "&dummy&" : promoProp(item)["set"];
}

function bundleKey(item) {
  return promoProp(item)["key"];
}

function post(url, body) {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json"
    }
  });
}


// try to parse a tag string into object
// sample: id:1011|rule:bundle|set:bundle-a&bundle-b|quantity:4&2
// bundle-a and bundle-b are collection handles
function parsePromoTag(tag) {
  const ret = {};
  tag.split('|').forEach(token => {
    [key, value] = token.split(':');

    if (key === 'set' || key === 'quantity') {
      ret[key] = value.split('&')
    }
    else {
      ret[key] = value;
    }

  })
  return ret;
}

function get(url) {
  return fetch(url, {
    credentials: "same-origin",
    method: "GET"
  });
}


// normal shopify ajax api
function getCart() {
  var url = "".concat(waveLiquidRoutes.cart, ".js?t=" + Date.now());
  return get(url).then(function (response) { return response.json(); });
}

// Refer to cart.json.liquid for exact structure, which will get both cart, and all mapped product
// WARNING: rmb to create the file "cart.json.liquid"
function getLiquidCart() {
  var url = "".concat(waveLiquidRoutes.cart, "?view=json&t=" + Date.now());
  return get(url).then(function (response) { return response.json(); });
}

// shopify add items to cart
async function addItems(items) {
  const resp = await post(waveLiquidRoutes.cartAdd, { items: items })

  const result = await resp.json()

  console.log(`result`, result)
  console.log(`resp`, resp.status)

  if (resp.status === 200) {
    return result
  }

  throw result
}

// change quantity of an item
async function changeItem(_a) {
  const { key, quantity, properties } = _a

  const resp = await post(waveLiquidRoutes.cartChange, {
    id: key,
    quantity: quantity,
    properties: properties
  })

  return resp
}

// remove item from cart using the item key
async function removeItem(key) {
  const resp = await post(waveCartUtils.cartChange, {
    id: key,
    quantity: 0,
  })
  return resp.json()
}

function isGiftItem(item) {
  return (item.properties || {})[PROPERTY_NAME_GIFT] == 'true';
}

function nonFreeGiftItems(cart) {
  return cart.items.filter(isGiftItem).filter(item => item.final_line_price > 0);
}

function rollingHash(s) {
  let ret = 0;
  let mod = 2147483647;
  let p = 307;
  let pp = 1;
  for (const i of s) {
    ret = (ret + (i.charCodeAt()) * pp) % mod
    pp = (pp * p) % mod;
  }
  return ret;
}

function calculateItemCount(cart) {

  let item_count = 0
  cart.items.map(item => {
    let bundle_key = ''
    let bundle_set = ''
    for (const [key, value] of Object.entries(item.properties)) {
      if (key === '__promo') {
        const { rule, key, set } = value
        if (rule === 'bundle') {
          bundle_key = key
          bundle_set = set
        }

      }
      console.log(`${key}: ${value}`);
    }

    if (!bundle_set) {
      item_count = item_count + item.quantity
    }
  })

  return item_count


  // assign item_count = 0
  // for item in cart.items
  //   for p in item.properties
  //     if p.first == '__promo'
  //       assign promo_rule = p.last.rule
  //       if promo_rule == 'bundle'
  //         assign bundle_key = p.last.key
  //         assign bundle_set = p.last.set
  //       endif
  //     endif
  //   endfor
  //   if bundle_set == blank
  //     assign item_count = item_count | plus: item.quantity
  //   endif
  // endfor

}

// logic for adding the Bundle to Cart
async function addBundleToCart(bundleInput) {

  const { selectedVariantList, bundleQuantity, bundleVariantId } = bundleInput

  // a key for saving what is selected
  const key = selectedVariantList.map(({ variantId, bundleCollectionHandle }) => `${bundleCollectionHandle}:${variantId}`).join('|');

  const sortKey = rollingHash(key);

  // add the contenet of the bundle
  const items = selectedVariantList.map(({ variantId, bundleCollectionHandle, quantity }) => {
    return {
      id: variantId,
      quantity: quantity * bundleQuantity,
      properties: {
        [PROPERTY_NAME_PROMO]: {
          key: key,
          rule: 'bundle',
          set: bundleCollectionHandle,
        },
        __sortKey: sortKey * 10 + 1
      }

    }
  })

  // add the dummy the cart
  items.push({
    id: bundleVariantId,
    quantity: bundleQuantity,
    properties: {
      [PROPERTY_NAME_PROMO]: {
        key: key,
        rule: 'bundle',
      },
      __sortKey: sortKey * 10
    }
  });

  const latestcart = await waveCartUtils.addItems(items);
  return latestcart
}

// bundle already in cart, just change the qty
async function changeBundleQuantity(bundleKey, bundleProductTag, quantity) {

  if (quantity === 0) {
    return removeBundle(bundleKey)
  }

  let cart = await waveCartUtils.getCart();

  const { set: setList, quantity: qunatityList } = parsePromoTag(bundleProductTag)

  const quantityMap = {}

  setList.map((bundleCollectionHandle, index) => {
    quantityMap[bundleCollectionHandle] = qunatityList[index]
  })

  console.log(`quantityMap`, quantityMap)

  for (const item of cart.items) {

    const itemPropkey = (item.properties['__promo'] || {})['key']
    const itemPropSet = (item.properties['__promo'] || {})['set']
  
    if (itemPropkey == bundleKey) {

      newQty = itemPropSet ? quantity * quantityMap[itemPropSet] : quantity

      cart = await waveCartUtils.changeItem({
        key: item.key,
        quantity: newQty
      }).then(r => r.json());

    }
  }

  return cart

}

async function removeBundle(bundleKey) {

  let latestCart = await waveCartUtils.getCart()

  for (const item of latestCart.items) {
    if ((item.properties['__promo'] || {})['key'] == bundleKey) {
      latestCart = await waveCartUtils.changeItem({
        key: item.key,
        quantity: 0
      }).then(r => r.json());
    }
  }

  return latestCart
}

async function bundleClean() {
  function isCheckingOut() {
    return (
      Shopify &&
      Shopify.Checkout &&
      (Shopify.Checkout.page === "show" ||
        Shopify.Checkout.page === "stock_problems")
    );
  }
  if (isCheckingOut()) {
    checkoutPageBundleCheck();
    return;
  }
  const { cart, products } = await getLiquidCart();
  const bundles = new Set();
  const expectedQty = {};
  for (const item of cart.items) {
    if (
      item.properties["__promo"] &&
      item.properties["__promo"]["rule"] == "bundle"
    ) {
      const key = item.properties["__promo"]["key"];
      const productSet = item.properties["__promo"]["set"] || "";

      if (!(key in expectedQty)) {
        expectedQty[key] = { "": 0 };
        for (const set of key.split("|").map((i) => i.split(":")[0])) {
          expectedQty[key][set] = 0;
        }
      }

      if (productSet in expectedQty[key]) {
        expectedQty[key][productSet] =
          expectedQty[key][productSet] + item.quantity;
      }
    }
  }
  console.log(expectedQty);

  let updated = false;
  for (const item of cart.items) {
    if (
      item.properties["__promo"] &&
      item.properties["__promo"]["rule"] == "bundle"
    ) {
      const key = item.properties["__promo"]["key"];
      const qty = Math.min(...(Object.values(expectedQty[key])));
      if (qty != item.quantity) {
        await changeItem({ key: item.key, quantity: qty });
        updated = true;
      }
    }
  }
  if (updated) {
    if (isCheckingOut()) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:build", {}));
    }
  }
}

// TODO: i don't know what is this
function bundleDiscount(product, set) {
  const tag = product.tags.find(t => t.startsWith(`set:${set}`));
  if (!tag) return 0;
  return Number(tag.split('discount:')[1]) * 100;
}

// based on the user input, calculate the bundle price (price of 1 bundle only)
function calculateBundlePrice(bundleProducts, bundleInput) {
  const { selectedVariantList, bundleQuantity } = bundleInput

  let originalPrice = 0;
  let discountedPrice = 0

  selectedVariantList.forEach(({ bundleCollectionHandle, variantId, quantity }) => {
    let product = null;
    let variant = null;
    for (const p of bundleProducts) {
      const v = p.variants.find(variant => variant.id == variantId);
      if (v) {
        variant = v;
        product = p;
      }
    }
    if (variant) {
      originalPrice += variant.price * quantity;
      discountedPrice += variant.price * quantity;
      discountedPrice -= (bundleDiscount(product, bundleCollectionHandle) * quantity);
    }
  })
  savedPrice = originalPrice - discountedPrice

  return {
    originalPrice: originalPrice,
    discountedPrice: discountedPrice,
    savedPrice: savedPrice
  }
}


// variants: list of variant json
// selectedOptions: { Color: 'Red', Size: 'Big' }
// options: ['Color', 'Size']
function getVariantFromOptions(product, selectedOptions) {

  console.log(`getVariantFromOptions`)
  console.log(`selectedOptions`, selectedOptions)

  const { options, variants } = product
  console.log(`options`, options)
  console.log(`variants`, variants)

  let foundVariant;

  variants.forEach((variant) => {

    let match = true

    options.forEach((optionKey, optionIndex) => {

      const selectedValue = selectedOptions[optionKey]

      if (variant.options[optionIndex] !== selectedValue) {
        match = false
      }
    })

    if (match) {
      foundVariant = variant
    }
  })

  if (!foundVariant) {
    console.error('no foundVariant')
  }

  console.log(`foundVariant`, foundVariant)

  return foundVariant
}


const waveCartUtils = {
  healthCheck,
  formatMoney,
  post,
  get,
  getCart,
  changeItem,
  addItems,
  removeItem,
  getVariantFromOptions
}

const wavePromoUtils = {
  calculateItemCount,
  addBundleToCart,
  calculateBundlePrice,
  //
  changeBundleQuantity,
  removeBundle,
  // 
  checkForCanRedeemPromoList,
}

